import React from 'react';

const link1 = <a href="https://www.dropbox.com/s/7jtgjl31jnn61g5/LGC_Leaflet_20180817%20%28US%29.pdf?dl=0" rel="noopener noreferrer" target="_blank">LG Chem Battery Presentation (PDF)</a>;

const Battery = () => (
    <div>
        <p className="specsText">LG is a leader in the home electronics industry and manufactures some of the most popular panels featured in quotes to shoppers on the EnergySage Solar Marketplace. Outside of making some of the highest quality solar panels on the market, LG’s battery subsidiary, LG Chem, produces one of the most popular batteries in the U.S. market: the LG Chem RESU 10H battery.
        </p>
        <p className="specsText">The LG Chem RESU pairs well with solar panel systems, especially if your utility has reduced or removed net metering, time-of-use rates, or demand charges. Installing a storage solution like the LG Chem RESU with a solar energy system allows you to maintain a sustained power supply during the day or night, as long as you store enough power from your panels when the sun is shining.
        </p>
        <p className="specsText">As with many other home battery products, the LG Chem RESU is sized for day-to-day use at your home and is often paired with a home solar panel system. When your solar panels produce more electricity than you can use in your home, you can store the excess electricity in the battery system instead of sending it back into the grid. Later, when your panels aren’t producing enough electricity to meet your home’s needs, you can use the electricity stored in your battery instead of having to buy it from your utility company.
        </p>
        <ul> <h1>Key Features</h1>
            <li className="specsText">Warranty period: 10 years or 27.4 MWh energy throughput</li>
            <li className="specsText">Throughput warranty: 27.4 megawatt-hours (MWh)</li>
            <li className="specsText">Guaranteed end of warranty capacity: 60%</li>
            <li className="specsText">{link1}</li>
        </ul>
    </div>
);


export default Battery;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/Batteries/lgchem.js